import {
  FDBodyText, FDImage, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import React from 'react';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { BorderedTransparentBox } from 'Packages/FacetDesign/Components/Experimental/BorderedTransparentBox';
import { dataAttrs } from 'Helpers/Testing';

const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['description'], {
    _component: () => FDBodyText,
  }, overrideReadOnly);

export const ProcessStep = ({ resource }) => {
  return (
    <BorderedTransparentBox>
      <FDStack
        direction={'row'}
        spacing={1}
        paddingX={2}
        paddingY={4}
        alignItems={'center'}
        {...dataAttrs('process-step')}
      >
        {resource.withRelationship(
          fr.relationships.icon.name,
          (rel) => (<FDImage
            alt={rel.meta('altText')}
            src={rel.link('related').url()}
            maxHeight={'48px'}
            rounded={false}
          />),
          () => null,
        )}
        <MetaControl resource={resource} metaOverrideSet={metaOverrides} attrName={'description'} />
      </FDStack>
    </BorderedTransparentBox>
  );
};

ProcessStep.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
